import { Navigate, Routes as ReactRoutes, Route } from 'react-router';

import { AppsPage } from './AppsPage';
import { ScopesPage } from './ScopesPage';
import { SearchCustomerPage } from './SearchCustomerPage';
import { TargetsPage } from './TargetsPage';

export function Routes() {
  return (
    <ReactRoutes>
      <Route path="/" element={<Navigate to="/apps" replace={true} />}></Route>
      <Route path="apps" element={<AppsPage />}></Route>
      <Route path="apps/:appId/scopes" element={<ScopesPage />}></Route>
      <Route path="apps/:appId/targets" element={<TargetsPage />}></Route>
      <Route path="search-customers" element={<SearchCustomerPage />} />
    </ReactRoutes>
  );
}
